import dayjs from 'dayjs';
import EmitAble from './emit-able';

export function leftTimer(time, isHour = false) {
  if (typeof time === 'string') {
	if (time.indexOf('T') !== -1) {
	  if (time.indexOf('+') === -1) {
		time += '+08:00';
	  }
	}
  }
  var leftTime = new Date(time).getTime() - new Date().getTime();
  if (leftTime <= 0) {
	return {
	  timeend: true,
	  days: pad(0),
	  hours: pad(0),
	  minutes: pad(0),
	  seconds: pad(0),
	};
  }
  /*  var days = parseInt(leftTime / 1000 / 60 / 60 / 24, 10)
   var hours = parseInt(leftTime / 1000 / 60 / 60 % 24, 10)
   var minutes = parseInt(leftTime / 1000 / 60 % 60, 10)
   var seconds = parseInt(leftTime / 1000 % 60, 10)
   return {
   days: pad(days),
   fullhours: pad(days * 24 + hours),
   hours: pad(hours),
   minutes: pad(minutes),
   seconds: pad(seconds)
   }*/
  return formatLeftTime(leftTime);
}

export class LeftTimer extends EmitAble {
  constructor({start, end}) {
	super();
	this.start = dayjs(start);
	this.end = dayjs(end);
	this.now = dayjs();
	this.startInterval();
  }

  get timeObj() {
	const {isStart, isEnd, isOnline} = this;

	let time = dayjs();
	if (isOnline) {
	  // 进行中,截至时间为end
	  time = dayjs(this.end);
	}
	else {
	  // 未开始
	  if (!isStart) {
		time = dayjs(this.start);
	  }
	  else {// 已开始又不在线,说明已结束
		let days = '00', fullhours = '00', hours = '00', minutes = '00', seconds = '00';
		return {days, fullhours, hours, minutes, seconds, isStart, isEnd, isOnline};
	  }
	}
	return {
	  ...formatLeftTime(time.diff(this.now)),
	  isStart, isEnd, isOnline
	};
  }

  get isStart() {
	return this.start.isBefore(this.now);
  }

  get isEnd() {
	return this.now.isAfter(this.end);
  }

  get isOnline() {
	return this.isStart && !this.isEnd;
  }

  startInterval() {
	this.timeID = setInterval(() => {
	  this.refreshDate();
	  this.fire('fresh', this.timeObj);
	  const fmt = d => d.format('YYYY-MM-DD HH:mm:ss');
	}, 1000);
  }

  refreshDate() {
	this.now = dayjs();
  }

  destroy() {
	clearInterval(this.timeID);
  }
}

export const formatLeftTime = (leftTime) => {
  var days = parseInt(leftTime / 1000 / 60 / 60 / 24, 10);
  var hours = parseInt(leftTime / 1000 / 60 / 60 % 24, 10);
  var minutes = parseInt(leftTime / 1000 / 60 % 60, 10);
  var seconds = parseInt(leftTime / 1000 % 60, 10);
  return {
	days: pad(days),
	fullhours: pad(days * 24 + hours),
	hours: pad(hours),
	minutes: pad(minutes),
	seconds: pad(seconds),
  };
};

export function pad(num, n = 2) {
  let len = num.toString().length;
  while (len < n) {
	num = '0' + num;
	len++;
  }
  return num;
}
